module.exports = __webpack_public_path__ + "static/the-doors-of-perception-bd8a3360b3ac83d017841f08df78ea2d.jpg";